/**
 * Models the healthcheck user configuration object
 */

import Brace from "backbone.brace";
import BackboneLocalStorateSync from "backbone-localstorage-sync";
import SimpleAlert from "../../utils/alerts/simple";
import { enabled, interval, LS_KEY } from "../../config/healthcheck";

const HealthcheckConfiguration = Brace.Model.extend({
  namedAttributes: {
    id: String,
    enabled: Boolean,
    interval: Number,
    intervalMin: Number,
    intervalMax: Number,
    lastUpdated: Date,
  },

  defaults: {
    id: "healthcheck",
    enabled,
    interval: interval.default,
    intervalMin: interval.min,
    intervalMax: interval.max,
    lastUpdated: null,
  },

  initialize() {
    // load current settings. it returns synchronously
    this.fetch();

    // listen for changes to the following properties
    this.listenTo(this, "change:enabled", this.onChange);
    this.listenTo(this, "change:interval", this.onChange);

    // listen for invalid model
    this.listenTo(this, "invalid", this.onInvalid);
  },

  // convert interval to milliseconds
  getIntervalMillis() {
    return this.getInterval() * 60 * 1000;
  },

  onChange() {
    this.set({
      lastUpdated: new Date(),
    });

    // persist changes
    this.save();
  },

  onInvalid(model, error) {
    const title = "Healthcheck has been disabled due to misconfiguration.";

    new SimpleAlert({
      title,
      text: error,
    });
  },

  validate(attrs) {
    // make sure interval is within the allowed range
    if (attrs.interval < attrs.intervalMin) {
      return `The interval must be greater than or equal to ${attrs.intervalMin} minutes.`;
    }
    if (attrs.interval > attrs.intervalMax) {
      return `The interval must be less than or equal to ${attrs.intervalMax} minutes.`;
    }
  },

  // @Override
  sync: BackboneLocalStorateSync(LS_KEY),
});

export { HealthcheckConfiguration as default };
